function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'reactstrap';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

class FileUploader extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleAcceptedFiles", files => {
      var allFiles = files;

      if (this.props.showPreview) {
        files.map(file => Object.assign(file, {
          preview: file['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null,
          formattedSize: this.formatBytes(file.size)
        }));
        allFiles = this.state.selectedFiles;
        allFiles.push(...files);
        this.setState({
          selectedFiles: allFiles
        });
      }

      if (this.props.onFileUpload) this.props.onFileUpload(allFiles);
    });

    _defineProperty(this, "formatBytes", (bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    });

    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.state = {
      selectedFiles: []
    };
  }
  /**
   * Handled the accepted files and shows the preview
   */


  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropzone, _extends({}, this.props, {
      onDrop: acceptedFiles => this.handleAcceptedFiles(acceptedFiles)
    }), ({
      getRootProps,
      getInputProps
    }) => /*#__PURE__*/React.createElement("div", {
      className: "dropzone"
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: "dz-message needsclick"
    }, getRootProps()), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement("i", {
      className: "h1 text-muted dripicons-cloud-upload"
    }), /*#__PURE__*/React.createElement("h5", null, "Drop files here or click to upload."), /*#__PURE__*/React.createElement("span", {
      className: "text-muted font-13"
    }, "(This is just a demo dropzone. Selected files are ", /*#__PURE__*/React.createElement("strong", null, "not"), " actually uploaded.)")))), this.props.showPreview && /*#__PURE__*/React.createElement("div", {
      className: "dropzone-previews mt-3",
      id: "file-previews"
    }, this.state.selectedFiles.map((f, i) => {
      return /*#__PURE__*/React.createElement(Card, {
        className: "mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete",
        key: i + '-file'
      }, /*#__PURE__*/React.createElement("div", {
        className: "p-2"
      }, /*#__PURE__*/React.createElement(Row, {
        className: "align-items-center"
      }, f.preview && /*#__PURE__*/React.createElement(Col, {
        className: "col-auto"
      }, /*#__PURE__*/React.createElement("img", {
        "data-dz-thumbnail": "",
        className: "avatar-sm rounded bg-light",
        alt: f.name,
        src: f.preview
      })), !f.preview && /*#__PURE__*/React.createElement(Col, {
        className: "col-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar-sm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "avatar-title bg-primary rounded"
      }, f.type.split('/')[0]))), /*#__PURE__*/React.createElement(Col, {
        className: "pl-0"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        className: "text-muted font-weight-bold"
      }, f.name), /*#__PURE__*/React.createElement("p", {
        className: "mb-0"
      }, /*#__PURE__*/React.createElement("strong", null, f.formattedSize))))));
    })));
  }

}

_defineProperty(FileUploader, "defaultProps", {
  showPreview: true
});

export default FileUploader;